import React from 'react';
import { Button } from './ui/button';
import { ExternalLink, Star, ShoppingBag, Zap } from 'lucide-react';

const MitzCart = () => {
  const features = [
    {
      icon: ShoppingBag,
      title: 'Flagship Marketplace',
      description: 'Our premier online retail platform offering thousands of quality products.'
    },
    {
      icon: Zap,
      title: 'Fast & Reliable',
      description: 'Lightning-fast delivery and reliable service across the UK.'
    },
    {
      icon: Star,
      title: 'Premium Quality',
      description: 'Carefully curated products meeting the highest quality standards.'
    }
  ];

  return (
    <section id="mitzcart" className="py-20 bg-blue-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Introducing MitzCart.com
          </h2>
          <p className="text-xl md:text-2xl mb-4 opacity-90">
            Our Flagship Online Marketplace & Retail Brand
          </p>
          <p className="text-lg opacity-80 max-w-3xl mx-auto">
            Experience the future of online shopping with MitzCart.com - where quality meets convenience. 
            Our comprehensive e-commerce platform brings you the best products from around the world, 
            delivered straight to your doorstep with unmatched service excellence.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-white mb-6">Why Choose MitzCart?</h3>
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                    <feature.icon className="text-white" size={24} />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-white mb-2">{feature.title}</h4>
                    <p className="text-blue-100">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-8 border border-white border-opacity-20">
            <h4 className="text-2xl font-bold text-white mb-6 text-center">Ready to Explore?</h4>
            <p className="text-blue-100 text-center mb-8">
              Discover thousands of products across electronics, fashion, health, lifestyle, 
              and home goods - all backed by our commitment to quality and customer satisfaction.
            </p>
            
            <div className="text-center">
              <Button 
                onClick={() => window.open('https://mitzcart.com', '_blank')}
                size="lg"
                className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 text-lg font-semibold transition-all duration-200 transform hover:scale-105"
              >
                <ExternalLink className="mr-2" size={20} />
                Visit MitzCart.com Now
              </Button>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="inline-flex items-center space-x-8 bg-white bg-opacity-10 backdrop-blur-sm rounded-full px-8 py-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-white">10,000+</div>
              <div className="text-blue-100 text-sm">Products</div>
            </div>
            <div className="w-px h-8 bg-white bg-opacity-30"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">50,000+</div>
              <div className="text-blue-100 text-sm">Happy Customers</div>
            </div>
            <div className="w-px h-8 bg-white bg-opacity-30"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-white">99.5%</div>
              <div className="text-blue-100 text-sm">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MitzCart;